const Menu =  [    
  {title: 'Login', name: 'login', meta:{public:true, guest:true}},
  {title: 'Device Register', name: 'device-register', meta:{public:true, guest:true}},
  {title: 'Register', name: 'register', meta:{public:true, guest:true}},
  {group: 'pages',
   items: [
     {title: 'Live Pilpres',name:'live', meta:{public:true, guest:true}},
   ] 
  },
  
  
  /*{        
    group: 'rbac',        
    items: [
        { title: 'Permission Form', name: 'permissions/form'},
        { title: 'Permission Option', name: 'permissions/view'},
        { title: 'Roles Form', name: 'roles/form'},
        { title: 'Roles Option', name: 'roles/view'},
        { title: 'User Option', name: 'assignment/view'},
    ]
  },*/
];

import Remenu from '@/util/remenu'
export default Remenu(Menu);